import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { getClientUserAddList } from "../Actions/ClientManagementAPI";
import { Multiselect } from "multiselect-react-dropdown";
let user = JSON.parse(localStorage.getItem("currentUser"));
class TechSuperintendent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TechSuperintendentIdsList:[],
            CommonArray:[],
            TechSuperintendentList: [],
        }
        this.addTechSuperintendent = this.addTechSuperintendent.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { TechSuperintendentlist } = nextProps;
       
        }
        componentDidMount() {
            this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
          var FinalArray= this.props?.TechSuperintendentlist;
          var FinalArray1=this.props.fleetManagerlist;
          var FinalArray2=this.props.TechExecutivelist
          this.state.CommonArray=this.props.fleetManagerArraylist;
          if (FinalArray && FinalArray.length > 0) {
            FinalArray.map((val, index) => {
              this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
            })
            this.setState({})
          }
          if (FinalArray1 && FinalArray1.length > 0) {
            FinalArray1.map((val, index) => {
              this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
            })
            this.setState({})
          }
          if (FinalArray2 && FinalArray2.length > 0) {
            FinalArray2.map((val, index) => {
              this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
            })
            this.setState({})
          }
       
      }

      onSelectChange(item) {
        this.state.TechSuperintendentIdsList = [];
        this.state.TechSuperintendentList = item;
        if (item && item.length > 0) {
          item.map((val, index) => {
            let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
            if (shipnames && shipnames.length > 0) {
              this.state.TechSuperintendentIdsList.push(shipnames[0].id);
            }
          })
        }
        this.setState({});
      }
    
      onRemoveChange(item) {
        this.state.TechSuperintendentIdsList = [];
        this.state.TechSuperintendentList = item;
        if (item && item.length > 0) {
          item.map((val, index) => {
            let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
            if (shipnames && shipnames.length > 0) {
              this.state.TechSuperintendentIdsList.push(shipnames[0].id);
             
            }
          })
        }
        this.setState({});
      }
    addTechSuperintendent() {
        const { dispatch } = this.props;
        if (this.state.TechSuperintendentIdsList !== [] ) {
          let FinalArray=[];
         /*  let FinalArray1=[];
          let FinalArray2=[]; */
          var CommonArray=[]
       /*    if(this.props.fleetManagerlist){
          this.props.fleetManagerlist.map((item)=>{
             if(item.clientUserId){
              FinalArray.push(item.clientUserId)
             }
          })
        } */
    /*     if(this.props.TechExecutivelist){
          this.props.TechExecutivelist.map((item)=>{
            if(item.clientUserId){
             FinalArray1.push(item.clientUserId)
            }
         })
        } */
        if(this.props.TechSuperintendentlist && this.props.TechSuperintendentlist.length){
         this.props.TechSuperintendentlist.map((item)=>{
          if(item.clientUserId){
           FinalArray.push(item.clientUserId)
          }
       })
      }

         /*  if(FinalArray.length>0 &&FinalArray1.length>0&& FinalArray2.length>0 ){
           CommonArray=[...FinalArray,...this.state.TechSuperintendentIdsList,...FinalArray1,...FinalArray2]
          }else if(FinalArray.length>0 &&FinalArray1.length>0){
              CommonArray=[...FinalArray,...this.state.TechSuperintendentIdsList,...FinalArray1]
          }else if(FinalArray.length>0&& FinalArray2.length>0){
            CommonArray=[...FinalArray,...this.state.TechSuperintendentIdsList,...FinalArray2]
          }else if(FinalArray1.length>0&& FinalArray2.length>0){
            CommonArray=[...FinalArray1,...this.state.TechSuperintendentIdsList,...FinalArray2]
          }else if(FinalArray1.length>0){
            CommonArray=[...FinalArray1,...this.state.TechSuperintendentIdsList]
          }else if(FinalArray2.length>0){
            CommonArray=[...this.state.TechSuperintendentIdsList,...FinalArray2]
          } */
          if(FinalArray.length>0){
            CommonArray=[...FinalArray,...this.state.TechSuperintendentIdsList]
          }
          else {
            CommonArray=[...this.state.TechSuperintendentIdsList]
          }
            dispatch(getClientUserAddList(CommonArray.toString(),"superintendent"))
             this.hideSidePanel()
            } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/ClientAdd");
    }

    render() {
        const { fleetManagerArraylist} = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Technical Superintendents</h5></div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-6">
                                   
                                    <label className="form-label">Email</label><br></br>
                                    <Multiselect
                      options={ this.state.CommonArray.length>0? this.state.CommonArray:fleetManagerArraylist}
                      displayValue="name"
                      showArrow={true}
                      isObject={true}
                      style={{
                        option: {"margin-right": 0,display: "block","font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={this.state.TechSuperintendentList}
                      placeholder={this.state.TechSuperintendentList && this.state.TechSuperintendentList.length? "": "Select"}
                      closeIcon="cancel"
                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                       <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechSuperintendent()}> Submit </button>
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
      fleetManagerArraylist: state.MasterScreenReducer.FleetManagerArrayList,
        TechSuperintendentlist:state.MasterScreenReducer.TechSuperintendentlist||[],
        fleetManagerlist: state.MasterScreenReducer.fleetManagerlist || [],
        TechExecutivelist:state.MasterScreenReducer.TechExecutivelist||[],
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TechSuperintendent));